// @flow
import {createActions} from 'redux-actions';

export const {
    checkoutOption: {setOptionShippingMethod, setOptionPaymentMethod},
} = createActions({
    CHECKOUT_OPTION: {
        SET_OPTION_SHIPPING_METHOD: () => {},
        SET_OPTION_PAYMENT_METHOD: () => {},
    },
});
